<template>
  <div class="MyTitle" :style="inputStyle">
    {{content}}
  </div>
</template>

<script>
 export default {
   name: 'MyTitle',
   props: ['content', 'inputStyle']
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .MyTitle{
   background-image: url(~@/assets/image/frontpage/bg-title.png);
   background-size: 12.5vw;
   color: white;
   width: 12.5vw;
   height: 3.4vw;
   display: flex;
   font-size: 1.8vw;
   justify-content:center;
   align-items: center;
 }
</style>
